<ion-icon name="add-outline" (click)="openBlockSector()"></ion-icon>